export const environment = {
  production: false,
  name: 'testing',
  apiUrl: 'https://testing-drinkhopping-api-zvzp.onrender.com/api/v1/'

  
}
